import { format, formatDistanceToNow, isValid } from 'date-fns';

// created_at is a zone-less UTC string from MySQL; tag it as UTC before parsing.
// Keep in sync with formatRelativeDateTime in dashboard tools/helpers.
export const formatUtcRelativeDateTime = (createdAt: string): string => {
  if (!createdAt) return '';
  const d = new Date(`${createdAt.replace(' ', 'T')}Z`);
  if (!isValid(d)) return createdAt;
  return `${formatDistanceToNow(d, { addSuffix: true })} (${format(d, 'MMM d, yyyy, h:mmaaa')})`;
};
